import { URLSearchParamsInit } from 'react-router-dom';
import { Params } from 'ahooks/lib/useAntdTable/types';
import { SorterResult } from 'antd/lib/table/interface';
import { RawAxiosRequestHeaders } from 'axios';
import { isObjectLike } from 'lodash';

import { apiGet } from 'api';

import { addQueryParamsToURL, getTableQueryParams, mapTreeSelectIds } from 'utils';

import { Retailer, RetailerGroupDto, RetailersGroupRequest, RetailersResponse } from 'codegen';
import { TRequestCallback } from 'types';

export const handleRetailersTableChange = (
  headers: RawAxiosRequestHeaders,
  setSearchParams: (data: URLSearchParamsInit) => void,
  setSortOrderInfo: (data: SorterResult<Retailer>) => void,
) => async (
  params: Params[0],
) => {
  const tableQueryParams = getTableQueryParams(params);

  setSearchParams(tableQueryParams);

  if (params.sorter?.field) {
    setSortOrderInfo(params.sorter);
  }

  const url = addQueryParamsToURL('/merchants', tableQueryParams);

  const { data } = await apiGet<RetailersResponse>({ url, headers });

  return {
    list: data.merchants,
    total: data.total,
  };
};

export const handlePatchRetailerGroups = (
  patchRetailersGroup: TRequestCallback<RetailersGroupRequest>,
) => ({
  id,
  groupName,
  retailers: ret,
}: RetailerGroupDto) => {
  const retailerIds = ret.some(isObjectLike)
    ? ret.map((merchant) => mapTreeSelectIds(merchant.id))
    : ret.map((ID) => mapTreeSelectIds(String(ID)));

  const payload = {
    groupName,
    retailerIds,
  };

  patchRetailersGroup({
    payload,
    callbackURL: `/retailers/groups/${id}`,
  });
};

export const handlePostRetailerGroups = (
  postRetailersGroup: TRequestCallback<RetailersGroupRequest>,
) => ({
  groupName,
  retailers,
}: RetailerGroupDto) => {
  const payload = {
    groupName,
    retailerIds: retailers.map((id) => mapTreeSelectIds(String(id))),
  };

  postRetailersGroup({ payload });
};
